module.exports = __webpack_public_path__ + "img/favicon.f0374448.ico";